import { RootState } from 'editor/src/store/index';

import findSpreadGroundImage from 'editor/src/util/design/findSpreadGroundImage';

const getSpreadMaskImage = (state: RootState, spreadName: string) =>
  findSpreadGroundImage(state.design.spreadMasks, spreadName);

export default getSpreadMaskImage;
